import { render, staticRenderFns } from "./utils-heroes-pop-edit.vue?vue&type=template&id=15d2d457&scoped=true"
import script from "./utils-heroes-pop-edit.vue?vue&type=script&lang=js"
export * from "./utils-heroes-pop-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2d457",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d2d457')) {
      api.createRecord('15d2d457', component.options)
    } else {
      api.reload('15d2d457', component.options)
    }
    module.hot.accept("./utils-heroes-pop-edit.vue?vue&type=template&id=15d2d457&scoped=true", function () {
      api.rerender('15d2d457', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/muiutils/views/heroes/utils-heroes-pop-edit.vue"
export default component.exports